const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- time-zone-dialog ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    value: String,
  }

  submit(event) {
    event.preventDefault()
    const zone = this.formData(event.target).time_zone
    if (zone) window.Dialog.close(zone)
  }

  CSS = `:fez {
display:block;.tzd-lead{margin-bottom:var(--space-4);color:var(--color-text-muted);font-size:var(--text-sm)}
}`

  HTML = `<form onsubmit="fez.submit(event)" novalidate>
<p class="tzd-lead">This browser does not say where you are. Every time is shown in the zone you choose here; you can change it later in Settings.</p>
<input-time-zone name="time_zone" label="Time zone" value={props.value}></input-time-zone>
<div class="dialog-actions">
<ui-button type="submit" variant="primary" label="Continue"></ui-button>
</div>
</form>`
};
}

Fez('time-zone-dialog', __fez_component_0);

export default __fez_component_0;
